import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import useDateFormat from "../useDateFormat";
import { DEFAULT_LOCALE, getSeparators } from "./i18n-separators";
const useI18N = (namespace) => {
    const i18nInfo = useTranslation(namespace);
    const currentLocale = useMemo(() => { var _a; return (_a = i18nInfo.i18n.language) !== null && _a !== void 0 ? _a : DEFAULT_LOCALE; }, [i18nInfo.i18n.language]);
    const separators = useMemo(() => getSeparators(currentLocale), [currentLocale]);
    const dateFormat = useDateFormat(currentLocale);
    return Object.assign(Object.assign(Object.assign({}, i18nInfo), dateFormat), { currentLocale, decimalSeparator: separators.decimal, thousandSeparator: separators.thousand });
};
export default useI18N;
